var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{class:_vm.data.enabled ? '' : 'disabled',attrs:{"href":"#"},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.grapesJSInstance === null ? 'Copy' : 'Select')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }